// extracted by mini-css-extract-plugin
export default {"container":"Gallery_container__W9wzU","img":"Gallery_img__q6svJ"};